// @flow

import createWebpackConfiguration from '../factories/createWebpackConfiguration';

export default createWebpackConfiguration('/');
